<table class="aui">
  <thead>
    <tr>
      <th>Title</th>
      <th>Vault</th>
      <th>Updated</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let note of notes">
      <tr>
        <td>
          <span style="cursor: pointer" title="{{ note.path }}">{{ note.title }}</span>
        </td>
        <td>{{ note.vaultName }}</td>
        <td>
          <app-lozenge [label]="note.updated | date : 'yyyy-MM-dd HH:mm:ss'" [subtle]="true"></app-lozenge>
        </td>
        <td>
          <button class="aui-button aui-button-link" (click)="viewNote(note)">
            {{ note.expanded ? 'Hide' : 'View' }}
          </button>
        </td>
      </tr>
      <tr class="aui-expander-content" *ngIf="note.expanded">
        <td colspan="5">
          <div *ngIf="!note.content">Loading...</div>
          <pre *ngIf="note.content" style="white-space: pre-wrap"><div [innerHTML]="note.formattedContent"></div>
            </pre>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
